import React, { useEffect } from "react";

import { useTheme } from "styled-components";

import Icon from "../../../../../../../../../components/ui/icon/Icon";
import { Tab, TabsContainer } from "./styles";
import { defaultBackgrounds } from "../Design";

const RoundedBackground = ({
  data,
  tab: { selectedTab, setSelectedTab },
  mode,
  macroId,
}) => {
  const theme = useTheme();

  const rawTextColor = data.colors.text[theme.name].toLowerCase();
  const rawAccentColor = data.colors.accent[theme.name].toLowerCase();

  const resolvedTextColor =
    rawTextColor === rawAccentColor
      ? defaultBackgrounds[theme.name]
      : rawTextColor;

  const resolvedAccentColor =
    rawAccentColor === defaultBackgrounds[theme.name]?.toLowerCase()
      ? rawTextColor
      : rawAccentColor;

  useEffect(() => {
    if (mode === "view") {
      window.AP.cookie.read(`caelor-optics-nested-tabs-${macroId}`, (value) => {
        if (value) {
          setSelectedTab(value);
        }
      });
    }
  }, [selectedTab]);

  useEffect(() => {
    if (mode !== "view") {
      setSelectedTab(data.tabs[0].value);
    }
  }, [data.tabs]);

  return (
    <TabsContainer>
      {data.tabs.map((tab) => (
        <Tab
          key={tab.value}
          textColor={resolvedTextColor}
          accentColor={resolvedAccentColor}
          isActive={selectedTab === tab.value}
          onClick={() => {
            setSelectedTab(tab.value);

            if (mode === "view") {
              window.AP.cookie.save(
                `caelor-optics-nested-tabs-${macroId}`,
                tab.value
              );
            }
          }}
        >
          {tab.icon && <Icon icon={tab.icon} size="18px" />}
          {tab.label}
        </Tab>
      ))}
    </TabsContainer>
  );
};

export default RoundedBackground;
